<template>
  <van-tabs class="family-cnt" v-model:active="active" color="#07c160">
    <van-tab title="数据解密">
      <Form>
        <van-field
            v-model="data.selectedPlatformDesc"
            is-link
            readonly
            name="picker"
            label="选择平台"
            placeholder="选择平台"
            @click="data.showPicker = true"
        />
        <van-popup v-model:show="data.showPicker" destroy-on-close position="bottom">
          <van-picker
              :columns="data.platforms"
              :model-value="data.selectedPlatformName"
              @confirm="onConfirm"
              @cancel="data.showPicker = false"
          />
        </van-popup>
        <van-field
            v-model="data.sourceData"
            rows="5"
            autosize
            label="原数据"
            type="textarea"
            placeholder="原数据"
        />
        <div class="button-wrap">
          <Button type="primary" @click="doSubmit">执行解密</Button>
        </div>
        <van-field
            v-model="data.decodedData"
            rows="5"
            autosize
            label="解密结果"
            type="textarea"
            placeholder="解密结果"
            readonly
        />
      </Form>
    </van-tab>
  </van-tabs>
</template>
<style lang="less">
@import "@/app.less";
.family-cnt{
  .van-cell__title{
    width: 6rem;
    color: @black1;
  }

  .van-field__control{
    color: #666;
  }

  .form-tips{
    color: @color2;
    text-align: left;
    padding: 0 1rem 0 1rem;
  }
  .button-wrap{
    display: flex;
    justify-content: space-evenly;
  }
}

</style>

<script>
import {Button, Field, Form, showToast} from "vant";
import {onMounted, ref} from "vue";
import API from "@/api";
const data = ref({
  platforms: [],
  sourceData:"",
  decodedData:"",
  selectedPlatformDesc: "之音",
  selectedPlatformName: ["zhiyin"],
  showPicker: false
});


export default {
  name: 'DebugView',
  components: {Form, Field, Button},
  setup(){
    onMounted(async () => {
      const res = await API.data.getPlatforms();
      if(res.success){
        if(res.data == null){
          res.data = [];
        }
        data.value.platforms = res.data.map((item) => {
          return {text: item.desc, value: item.name};
        });
      }
    });

    return {data};
  },
  methods: {
    doSubmit: async function () {
      if(data.value.sourceData == null || data.value.sourceData.trim() === ""){
        showToast({type: 'warning', message: '请输入要解密的数据'});
        return;
      }

      const res = await API.data.doDataDecode({platform: data.value.selectedPlatformName[0], data: data.value.sourceData});
      if(res.success){
        data.value.decodedData = res.data;
      }else{
        showToast({type: 'warning', message: res.errorMsg})
      }
    },
    onConfirm({ selectedValues, selectedOptions }) {
      console.log(selectedValues, selectedOptions);
      data.value.selectedPlatformName = selectedValues;
      data.value.selectedPlatformDesc = selectedOptions[0].text;
      data.value.showPicker = false;
    }
  }
}
</script>
